/**
 * API Configuration
 * Update these endpoints to match your backend API
 */

const ENV = "development";

const BASE_URLS: Record<string, string> = {
  domain: "https://backend.whitebench.co",
  development: "https://backend.whitebench.co/api",
  production: "https://backend.whitebench.co/api",

  // domain: "https://packtivate-prod-s3-bucket.s3.ap-south-1.amazonaws.com/",
  // development: "https://pactivatebackend.packtivate.io/api",
  // production: "https://pactivatebackend.packtivate.io/api",
};

// During local Vite development, use the same-origin proxy. This lets the
// browser store and send the HttpOnly refresh cookie on localhost instead of
// treating the API host as a cross-site request.

export const API_CONFIG = {
  domain: BASE_URLS["domain"],
  baseUrl: BASE_URLS[ENV],
  endpoints: {
    auth: {
      login: "/doctors/auth/login-with-pass",
      signup: "/doctors/onboarding-form",
      associationslist: "/doctors/associations-list",
      forgotpassword_req_otp: "/doctors/auth/forgot-password/request-otp",
      forgotpassword_verifyotp: "/doctors/auth/forgot-password/verify-otp",
      forgotpassword: "doctors/auth/forgot-password/reset",
      resetpassword: "/doctors/auth/change-password",
      refresh: "/doctors/auth/refresh-token",
      logout: "/doctors/auth/logout",
      verifyMfa: "/doctors/auth/2fa/verify-login",
      generateMfa: "/auth/mfa/generate-setup",
      enableMfa: "/doctors/auth/2fa/setup/confirm",
      disableMfa: "/doctors/auth/2fa/disable",
      sendLoginOtp: "/doctors/auth/login-otp/request",
      verifyLoginOtp: "/doctors/auth/login-otp/verify",
    },
    invite: {
      getinvites: "/doctors/associations/invites/:doctor_id",
    },
    engagement: {
      requests: "/doctors/pharma/engagement-requests",
      respond: "/doctors/pharma/engagement-requests/:request_id/respond",
    },

    dashboard: {
      getStats: "/doctors/dashboard/stat-cards/:association_id",
      programmeChart: "/doctors/dashboard/program-stat-chart/:association_id",
    },
    programme: {
      getProgrammes: "/doctors/programs-list/:association_id",
      doctorPrograms: "/doctors/programs-list",
      createProgrammes: "/doctors/create-program",
      updateProgrammes: "/doctors/update-program/:program_id",
      dropdownlist: "/doctors/association-programs-dropdown/:associationId",
      invite: "/doctors/program-invite",
      doctorDropdown: "/doctors/doctors/:associationId",
      sendInvite: "/doctors/program-invite",
    },

    members: {
      getstatdata: "/doctors/member/stat-cards/:associationId",
      addmembers: "/doctors/member/send-invite-single",
      uploadmembers: "/doctors/member/send-invite",
      listMemebers: "/doctors/member/list/:association_id",
      memberDetails: "/doctors/member/details/:association_member_id",
      inviteMemebers: "/doctors/member/invite-list/:associationId",
      memberRequests: "/doctors/member/request-list/:association_id",
      updateRequest: "/doctors/member/update-request-status/:request_id",
      deleteRequest: "/doctors/member/delete-invite",
      resendRequest: "/doctors/member/resend-member-invite",
    },

    attendance: {
      getprogrammedata: "/doctors/program-invite-details/:attendanceToken",
      attendanceList: "/doctors/program-attendance-list/:programId",
      updateStatus: "/doctors/program-credit/manage/:programId",
      attendanceOtp: "/doctors/program-attendance/send-otp",
      verifyAttendanceOtp: "/doctors/program-attendance/verify-otp",
    },

    user: {
      getProfileData: "/doctors/profile",
      updateProfile: "/doctors/update-profile",
      passwordReset: "/doctors/auth/forgot-password/reset",
      passwordResetReqOtp: "/doctors/auth/forgot-password/request-otp",
      passwordResetVerifyOtp: "/doctors/auth/forgot-password/verify-otp",
      setupMfa: "/doctors/auth/2fa/setup",
      confirmMfa: "/doctors/auth/2fa/setup/confirm",
      cancelMfa: "/doctors/auth/2fa/disable",
      vertifyphonerequestotp: "/doctors/update-profile/phone/request",
      vertifyphoneverifyotp: "/doctors/update-profile/phone/verify",
      vertifyEmailRequestOtp: "/doctors/send-verify-email",
      updateNotification:
        "doctors/update-notification-settings/:association_id",
    },
    kyc: {
      details: "/doctors/kyc/details",
      pan: "/doctors/kyc/pan",
      aadhaar: "/doctors/kyc/aadhaar",
    },
    bankAccounts: {
      list: "/doctors/bank-accounts",
      add: "/doctors/bank-accounts",
      setPrimary: "/doctors/bank-accounts/:bank_account_id/set-primary",
      updateStatus: "/doctors/bank-accounts/:bank_account_id/update-status",
    },
  },
};

/**
 * Get full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = API_CONFIG.baseUrl.replace(/\/$/, "");
  const path = endpoint.replace(/^\//, "");

  return `${baseUrl}/${path}`;
};

/**
 * Replace URL parameters
 */
export const replaceUrlParams = (
  url: string,
  params: Record<string, string>,
): string => {
  let result = url;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, encodeURIComponent(value));
  });
  return result;
};
